import React from "react";
import { Loader2 } from "lucide-react";

export function PageHeader({ overline, title, subtitle, actions, testid }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8" data-testid={testid}>
      <div>
        {overline && <div className="overline text-krida-emerald mb-2">{overline}</div>}
        <h1 className="font-heading uppercase tracking-tight text-3xl sm:text-4xl font-extrabold text-slate-50">{title}</h1>
        {subtitle && <p className="text-slate-400 mt-1 max-w-2xl text-sm sm:text-base">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2 flex-shrink-0">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, icon: Icon, accent = "crimson", sub, testid }) {
  const colors = {
    crimson: "text-krida-crimson", emerald: "text-krida-emerald",
    cobalt: "text-krida-cobalt", amber: "text-krida-amber", slate: "text-slate-300",
  };
  return (
    <div className="krida-card p-5 transition-all duration-200 hover:-translate-y-0.5" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div className="overline text-slate-500">{label}</div>
        {Icon && <Icon className={`w-4 h-4 ${colors[accent]}`} />}
      </div>
      <div className={`font-mono text-3xl font-bold mt-3 ${colors[accent]}`}>{value}</div>
      {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
    </div>
  );
}

export function Tag({ children, tone = "slate" }) {
  const tones = {
    slate: "bg-slate-100 text-slate-600 border-slate-300",
    emerald: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
    crimson: "bg-rose-500/10 text-rose-400 border-rose-500/30",
    cobalt: "bg-blue-500/10 text-blue-400 border-blue-500/30",
    amber: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  };
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-mono font-semibold uppercase tracking-wider border ${tones[tone]}`}>
      {children}
    </span>
  );
}

export function statusTone(status) {
  const s = (status || "").toLowerCase();
  if (["verified", "paid", "completed", "confirmed", "available", "approved", "on time"].includes(s)) return "emerald";
  if (["pending", "processing", "tentative", "requested", "scheduled", "invited", "workforce planning"].includes(s)) return "amber";
  if (["expired", "rejected", "absent", "replacement", "shortage", "requires update"].includes(s)) return "crimson";
  if (["checked_in", "in_progress", "accepted", "assigned", "open"].includes(s)) return "cobalt";
  return "slate";
}

export function Loader({ label = "Loading" }) {
  return (
    <div className="flex items-center justify-center py-24 text-slate-500 gap-3">
      <Loader2 className="w-5 h-5 animate-spin text-krida-crimson" />
      <span className="font-mono text-sm">{label}…</span>
    </div>
  );
}

export function Empty({ label = "No records yet" }) {
  return <div className="text-center py-16 text-slate-500 font-mono text-sm border border-dashed border-slate-800 rounded-xl">{label}</div>;
}
